// Interval lanes keep intentionally overlapping bookings individually visible.
export function calendarLanes(items,start,end){
    const result=new Map();let group=[],runningEnd=-Infinity;
    const flush=()=>{
        const ends=[];
        for(const row of group){let lane=ends.findIndex(at=>at<=row.start);if(lane<0)lane=ends.length;ends[lane]=row.end;row.lane=lane;}
        const count=Math.max(1,ends.length);
        for(const row of group)result.set(row.id,{left:row.lane*100/count,width:100/count,count});
        group=[];runningEnd=-Infinity;
    };
    for(const row of items.map(item=>({id:item.id,start:start(item),end:end(item)})).sort((a,b)=>a.start-b.start||a.end-b.end)){
        if(group.length&&row.start>=runningEnd)flush();
        group.push(row);runningEnd=Math.max(runningEnd,row.end);
    }
    flush();return result;
}
